module.exports = __webpack_public_path__ + "static/media/no_data.3381746b.png";